import { lastValueFrom, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { TableQueryParams } from '../models/table-query-params';
import { PagedResponse } from '../models/paged-response';
import { TableUtils } from '../utils/table.utils';

export abstract class CrudService<T> {
  private dataChangedSubject: Subject<boolean> = new Subject<boolean>();

  public dataChanged$(): Observable<boolean> {
    return this.dataChangedSubject.asObservable();
  }

  protected constructor(protected http: HttpClient, protected endpoint: string) {}

  getAll(params: TableQueryParams): Promise<PagedResponse<T>> {
    const queryParams = TableUtils.prepareForApiParams(params);
    return lastValueFrom(this.http.get<PagedResponse<T>>(this.endpoint, { params: queryParams }));
  }

  getOne(id: string): Promise<T> {
    return lastValueFrom(this.http.get<T>(`${this.endpoint}/${id}`));
  }

  async deleteOne(id: string) {
    const result = await lastValueFrom(this.http.delete(`${this.endpoint}/${id}`));
    this.dataChangedSubject.next(true);
    return result;
  }

  async updateOne(id: string, data: Partial<T>) {
    const result = await lastValueFrom(this.http.put<T>(`${this.endpoint}/${id}`, data));
    this.dataChangedSubject.next(true);
    return result;
  }

  async partiallyUpdateOne(id: string, data: Partial<T>) {
    const result = await lastValueFrom(this.http.patch<T>(`${this.endpoint}/${id}`, data));
    this.dataChangedSubject.next(true);
    return result;
  }

  async addOne(data: Partial<T>) {
    const result = await lastValueFrom(this.http.post<T>(this.endpoint, data));
    this.dataChangedSubject.next(true);
    return result;
  }
}
